import { createFileRoute, useParams } from '@tanstack/react-router';

import { AssessmentBulkAssignScreen } from '@/features/assessments/components/workspace/AssessmentBulkAssignScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/assessments/$templateId/bulk-assign')(
  {
    beforeLoad: () => {
      requirePermission('assessment:assign');
    },
    component: Wrap,
    staticData: { crumb: 'Bulk assign' },
  },
);

function Wrap() {
  const { templateId } = useParams({
    from: '/_staff/admin/workspace/assessments/$templateId/bulk-assign',
  });
  return <AssessmentBulkAssignScreen templateId={templateId} />;
}
